import React from 'react';
import { Section } from './ui/Section';
import { Brain } from 'lucide-react';
export function RealProblemSection() {
  return <Section background="midnight" data-id="element-167">
      <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-168">
        <div className="w-full md:w-1/3 flex justify-center" data-id="element-169">
          <div className="w-32 h-32 md:w-48 md:h-48 rounded-full bg-[#1e1b4b] flex items-center justify-center border border-[#d4a574]/20 shadow-[0_0_40px_rgba(212,165,116,0.1)]" data-id="element-170">
            <Brain size={64} className="text-[#d4a574] opacity-80" strokeWidth={1} data-id="element-171" />
          </div>
        </div>

        <div className="w-full md:w-2/3" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-173">
            El problema real: tu mente no busca calma.{' '}
            <span className="text-[#d4a574]" data-id="element-174">Busca cierre.</span>
          </h2>

          <div className="space-y-6 text-lg text-slate-300 leading-relaxed" data-id="element-175">
            <p data-id="element-176">
              Cuando hay silencio, tu cerebro intenta protegerte: repasa
              riesgos, pendientes, decisiones, conversaciones.
            </p>
            <p data-id="element-177">No porque seas dramática.</p>
            <p className="text-white font-medium" data-id="element-178">
              Porque estás sosteniendo demasiado.
            </p>
            <p data-id="element-179">
              Y si tu cerebro siente que "algo importante" puede perderse… no va
              a dejarte dormir.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}